import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';

import IconArrow from '../../atoms/icons/icon-arrow';
import TypograpyHeadingComponent from '../../foundation/typography/typography-heading/typography-heading';
import TypographyElements from '../../foundation/typography/typography-element/typography-elements';
import { ISubSection, ISubSubSection } from '../../../typings/hlroom';
import styles from '../../../utils/styles';
import useAdvRewarded from '../../../hooks/useAdvRewarded';
import Timer from '../../atoms/player/timer/Timer';

import './SubSectionHeader.scss';

export interface ISubSectionHeader {
  isDesktop: boolean;
  subSection: ISubSection;
  subSubSection?: ISubSubSection;
  isOpen?: boolean;
  onClick?: any;
  noVideosByFilter?: boolean;
  onVisibilityChangeSubSection?: (value: boolean) => void;
}

const SubSectionHeader: React.FC<ISubSectionHeader> = ({
  isDesktop,
  subSection,
  subSubSection,
  isOpen = false,
  onClick,
  noVideosByFilter,
  onVisibilityChangeSubSection,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, { threshold: 0.2 });
  const [title, setTitle] = useState<string>('');
  const [hasMenu, setHasMenu] = useState<boolean>(false);
  const [timerStatus, timerElapsed] = useAdvRewarded(0);

  useEffect(() => {
    if (!isDesktop && onVisibilityChangeSubSection) {
      if (!entry?.isIntersecting) {
        return onVisibilityChangeSubSection(false);
      }
      onVisibilityChangeSubSection(true);
    }
  }, [entry?.isIntersecting, isDesktop]);

  useEffect(() => {
    !isDesktop && setTitle(!subSubSection ? `Tutto ${subSection.name}` : subSubSection.name);
    isDesktop && setTitle(`Tutto ${subSection.name}`);
    !isDesktop && setHasMenu(subSection.subSubSections.length > 0);
  }, [isDesktop, subSection, subSubSection]);

  return (
    <div className={styles('subsection__header')} ref={!isDesktop ? ref : null}>
      {!noVideosByFilter && <TypograpyHeadingComponent text={title} headingTag="h2" />}
      {!noVideosByFilter && hasMenu && (
        <div style={{ display: 'flex' }} onClick={!isDesktop ? onClick : null}>
          <IconArrow rotate={isOpen} />
        </div>
      )}
      {isDesktop && timerStatus === 'progress' && (
        <Fragment>
          <Timer elapsed={timerElapsed} expanded expandable />
          <div className={styles('divider')} />
        </Fragment>
      )}
      {isDesktop && (
        <div onClick={isDesktop ? onClick : null}>
          <TypographyElements
            text="ULTIMI VIDEO"
            typographyClass={styles(
              'ty-elements-medium--uppercase',
              'header__text',
              Boolean(!subSubSection) && 'header__text--active'
            )}
          />
        </div>
      )}
    </div>
  );
};

export default SubSectionHeader;
